import React from 'react';

const PlayIconSvg = () => {

  return(
    <svg
      style = {{"display": "none"}}
      className = "immersive-lightbox__play-icon-template"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink = "http://www.w3.org/1999/xlink"
    >
      <g fill="none" fillRule="evenodd" id="immersive-lightbox-play-icon-shape">

        <path
          d="M6,4.97342543 C6,4.10622619 6.61591129,3.75146181 7.36867369,4.18504984 L20.4354108,11.7116309 C21.1881964,12.1452421 21.1881964,12.8547709 20.4354108,13.2883821 L7.36867369,20.81494 C6.61591129,21.2485512 6,20.8937636 6,20.0265644 L6,4.97342543 Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export {PlayIconSvg};